module.exports = __webpack_public_path__ + "img/empty-black-block.1cd495d9.png";